/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DeliveryPackageByDriverResponse } from '../model';
// @ts-ignore
import { PagedResponseDeliveryPackageResponse } from '../model';
// @ts-ignore
import { PagedResponseDeliveryReviewResponse } from '../model';
/**
 * AdminDeliveryControllerApi - axios parameter creator
 * @export
 */
export const AdminDeliveryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} date 
         * @param {string} [userId] 
         * @param {string} [dietitianId] 
         * @param {string} [affiliateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMealBoxStickers: async (date: string, userId?: string, dietitianId?: string, affiliateId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('downloadMealBoxStickers', 'date', date)
            const localVarPath = `/admin/delivery/meal-box-stickers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (dietitianId !== undefined) {
                localVarQueryParameter['dietitianId'] = dietitianId;
            }

            if (affiliateId !== undefined) {
                localVarQueryParameter['affiliateId'] = affiliateId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {string} mealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMealDailyUsers: async (date: string, mealId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('downloadMealDailyUsers', 'date', date)
            // verify required parameter 'mealId' is not null or undefined
            assertParamExists('downloadMealDailyUsers', 'mealId', mealId)
            const localVarPath = `/admin/delivery/meal-daily-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            if (mealId !== undefined) {
                localVarQueryParameter['mealId'] = mealId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {string} [userId] 
         * @param {string} [dietitianId] 
         * @param {string} [affiliateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMealPackageStickers: async (date: string, userId?: string, dietitianId?: string, affiliateId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('downloadMealPackageStickers', 'date', date)
            const localVarPath = `/admin/delivery/meal-package-stickers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (dietitianId !== undefined) {
                localVarQueryParameter['dietitianId'] = dietitianId;
            }

            if (affiliateId !== undefined) {
                localVarQueryParameter['affiliateId'] = affiliateId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {string} [area] 
         * @param {number} [zone] 
         * @param {string} [driverId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackagesByDate: async (date: string, area?: string, zone?: number, driverId?: string, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('listPackagesByDate', 'date', date)
            const localVarPath = `/admin/delivery/packages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (zone !== undefined) {
                localVarQueryParameter['zone'] = zone;
            }

            if (driverId !== undefined) {
                localVarQueryParameter['driverId'] = driverId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {string} [area] 
         * @param {number} [zone] 
         * @param {string} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackagesByDrivers: async (date: string, area?: string, zone?: number, driverId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('listPackagesByDrivers', 'date', date)
            const localVarPath = `/admin/delivery/drivers/packages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (zone !== undefined) {
                localVarQueryParameter['zone'] = zone;
            }

            if (driverId !== undefined) {
                localVarQueryParameter['driverId'] = driverId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {number} [userExternalId] 
         * @param {string} [userName] 
         * @param {ListReviewsByDateStatusEnum} [status] 
         * @param {string} [driverId] 
         * @param {string} [dietitianId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReviewsByDate: async (date: string, userExternalId?: number, userName?: string, status?: ListReviewsByDateStatusEnum, driverId?: string, dietitianId?: string, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('listReviewsByDate', 'date', date)
            const localVarPath = `/admin/delivery/reviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            if (userExternalId !== undefined) {
                localVarQueryParameter['userExternalId'] = userExternalId;
            }

            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (driverId !== undefined) {
                localVarQueryParameter['driverId'] = driverId;
            }

            if (dietitianId !== undefined) {
                localVarQueryParameter['dietitianId'] = dietitianId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDeliveryControllerApi - functional programming interface
 * @export
 */
export const AdminDeliveryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDeliveryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} date 
         * @param {string} [userId] 
         * @param {string} [dietitianId] 
         * @param {string} [affiliateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadMealBoxStickers(date: string, userId?: string, dietitianId?: string, affiliateId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadMealBoxStickers(date, userId, dietitianId, affiliateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {string} mealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadMealDailyUsers(date: string, mealId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadMealDailyUsers(date, mealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {string} [userId] 
         * @param {string} [dietitianId] 
         * @param {string} [affiliateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadMealPackageStickers(date: string, userId?: string, dietitianId?: string, affiliateId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadMealPackageStickers(date, userId, dietitianId, affiliateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {string} [area] 
         * @param {number} [zone] 
         * @param {string} [driverId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPackagesByDate(date: string, area?: string, zone?: number, driverId?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResponseDeliveryPackageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPackagesByDate(date, area, zone, driverId, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {string} [area] 
         * @param {number} [zone] 
         * @param {string} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPackagesByDrivers(date: string, area?: string, zone?: number, driverId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeliveryPackageByDriverResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPackagesByDrivers(date, area, zone, driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {number} [userExternalId] 
         * @param {string} [userName] 
         * @param {ListReviewsByDateStatusEnum} [status] 
         * @param {string} [driverId] 
         * @param {string} [dietitianId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReviewsByDate(date: string, userExternalId?: number, userName?: string, status?: ListReviewsByDateStatusEnum, driverId?: string, dietitianId?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResponseDeliveryReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReviewsByDate(date, userExternalId, userName, status, driverId, dietitianId, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminDeliveryControllerApi - factory interface
 * @export
 */
export const AdminDeliveryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDeliveryControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} date 
         * @param {string} [userId] 
         * @param {string} [dietitianId] 
         * @param {string} [affiliateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMealBoxStickers(date: string, userId?: string, dietitianId?: string, affiliateId?: string, options?: any): AxiosPromise<File> {
            return localVarFp.downloadMealBoxStickers(date, userId, dietitianId, affiliateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {string} mealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMealDailyUsers(date: string, mealId: string, options?: any): AxiosPromise<File> {
            return localVarFp.downloadMealDailyUsers(date, mealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {string} [userId] 
         * @param {string} [dietitianId] 
         * @param {string} [affiliateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMealPackageStickers(date: string, userId?: string, dietitianId?: string, affiliateId?: string, options?: any): AxiosPromise<File> {
            return localVarFp.downloadMealPackageStickers(date, userId, dietitianId, affiliateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {string} [area] 
         * @param {number} [zone] 
         * @param {string} [driverId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackagesByDate(date: string, area?: string, zone?: number, driverId?: string, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedResponseDeliveryPackageResponse> {
            return localVarFp.listPackagesByDate(date, area, zone, driverId, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {string} [area] 
         * @param {number} [zone] 
         * @param {string} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackagesByDrivers(date: string, area?: string, zone?: number, driverId?: string, options?: any): AxiosPromise<Array<DeliveryPackageByDriverResponse>> {
            return localVarFp.listPackagesByDrivers(date, area, zone, driverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {number} [userExternalId] 
         * @param {string} [userName] 
         * @param {ListReviewsByDateStatusEnum} [status] 
         * @param {string} [driverId] 
         * @param {string} [dietitianId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReviewsByDate(date: string, userExternalId?: number, userName?: string, status?: ListReviewsByDateStatusEnum, driverId?: string, dietitianId?: string, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedResponseDeliveryReviewResponse> {
            return localVarFp.listReviewsByDate(date, userExternalId, userName, status, driverId, dietitianId, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminDeliveryControllerApi - object-oriented interface
 * @export
 * @class AdminDeliveryControllerApi
 * @extends {BaseAPI}
 */
export class AdminDeliveryControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} date 
     * @param {string} [userId] 
     * @param {string} [dietitianId] 
     * @param {string} [affiliateId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryControllerApi
     */
    public downloadMealBoxStickers(date: string, userId?: string, dietitianId?: string, affiliateId?: string, options?: AxiosRequestConfig) {
        return AdminDeliveryControllerApiFp(this.configuration).downloadMealBoxStickers(date, userId, dietitianId, affiliateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {string} mealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryControllerApi
     */
    public downloadMealDailyUsers(date: string, mealId: string, options?: AxiosRequestConfig) {
        return AdminDeliveryControllerApiFp(this.configuration).downloadMealDailyUsers(date, mealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {string} [userId] 
     * @param {string} [dietitianId] 
     * @param {string} [affiliateId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryControllerApi
     */
    public downloadMealPackageStickers(date: string, userId?: string, dietitianId?: string, affiliateId?: string, options?: AxiosRequestConfig) {
        return AdminDeliveryControllerApiFp(this.configuration).downloadMealPackageStickers(date, userId, dietitianId, affiliateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {string} [area] 
     * @param {number} [zone] 
     * @param {string} [driverId] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryControllerApi
     */
    public listPackagesByDate(date: string, area?: string, zone?: number, driverId?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return AdminDeliveryControllerApiFp(this.configuration).listPackagesByDate(date, area, zone, driverId, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {string} [area] 
     * @param {number} [zone] 
     * @param {string} [driverId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryControllerApi
     */
    public listPackagesByDrivers(date: string, area?: string, zone?: number, driverId?: string, options?: AxiosRequestConfig) {
        return AdminDeliveryControllerApiFp(this.configuration).listPackagesByDrivers(date, area, zone, driverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {number} [userExternalId] 
     * @param {string} [userName] 
     * @param {ListReviewsByDateStatusEnum} [status] 
     * @param {string} [driverId] 
     * @param {string} [dietitianId] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryControllerApi
     */
    public listReviewsByDate(date: string, userExternalId?: number, userName?: string, status?: ListReviewsByDateStatusEnum, driverId?: string, dietitianId?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return AdminDeliveryControllerApiFp(this.configuration).listReviewsByDate(date, userExternalId, userName, status, driverId, dietitianId, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListReviewsByDateStatusEnum = {
    PendingReview: 'PENDING_REVIEW',
    Reviewed: 'REVIEWED'
} as const;
export type ListReviewsByDateStatusEnum = typeof ListReviewsByDateStatusEnum[keyof typeof ListReviewsByDateStatusEnum];
